import {
  CHANGE_SPINE_BACKGROUND_COLOR,
  LOAD_SPINE_DEFAULTS,
  CHANGE_SPINE_COLOR,
  CHANGE_SPINE_TEXT,
  CHANGE_FONT_SIZE,
  CHANGE_FONT_FAMILY,
  LOAD_COVER_DETAILS_BY_BOOK_ID,
} from '../../action-types/entities/cover';

export const loadSpineDefaults = () => ({ type: LOAD_SPINE_DEFAULTS });
export const changeSpineBackgroundColor = backgroundColor => ({
  type: CHANGE_SPINE_BACKGROUND_COLOR,
  backgroundColor,
});
export const changeSpineColor = color => ({
  type: CHANGE_SPINE_COLOR,
  color,
});

export const changeSpineText = text => ({
  type: CHANGE_SPINE_TEXT,
  text,
});

export const changeFontSize = fontSize => ({
  type: CHANGE_FONT_SIZE,
  fontSize,
});

export const changeFontFamily = fontFamily => ({
  type: CHANGE_FONT_FAMILY,
  fontFamily,
});

export const loadCoverDetailsByBookId = bookstate => ({
  type: LOAD_COVER_DETAILS_BY_BOOK_ID,
  bookstate,
});



// WEBPACK FOOTER //
// ./src/redux/actions/entities/cover.js